import { render, staticRenderFns } from "./OtherProceedingInfo.vue?vue&type=template&id=7897cfc0&"
import script from "./OtherProceedingInfo.vue?vue&type=script&lang=js&"
export * from "./OtherProceedingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports